import { SVGProps } from 'react';
import { ReactComponent as LogoSrc } from "./logo.svg";
const Logo = ({ ...props }: SVGProps<SVGSVGElement>) => {
    return <LogoSrc {...props} />;
};

export default Logo;
